import { I18nKeyUtils } from '@smooved/core';
import { i18nKeyTypeMap, uiI18nKeyTypes } from '../../i18n/i18n-key-type-map.constants';

export const i18nStreet = I18nKeyUtils.map(i18nKeyTypeMap, uiI18nKeyTypes.Address, 'STREET');
